export default __webpack_public_path__ + "static/media/grotesque-eng .90a4ce92.png";